import React from "react";
import { useLocation, useParams } from "react-router-dom";
import SideNavItem from "./SideNavItem";

const SideNav = () => {
  const location = useLocation();
  const { id } = useParams();

  // Update isActive to handle both single and multiple paths
  const isActive = (paths) => {
    // Ensure paths is an array, so it works both for single path and array of paths
    const pathArray = Array.isArray(paths) ? paths : [paths];
    return pathArray.every((path) => location.pathname.includes(path));
  };

  return (
    <div className="col-md-3">
      <div className="row">
        <div className="col-md-12">
          <div className="list-group">
            <span
              href="#"
              className="list-group-item"
              style={{ color: "#3c8dbc" }}
            >
              <b>Application Form</b>
            </span>

            <SideNavItem
              href={`/emp/op/app-form/${id}/basic`}
              label="Basic Information"
              icon="fa-info-circle"
              isActive={isActive(["/emp/op/app-form", "/basic"])}
              showError={true}
            />

            <SideNavItem
              href={`/emp/op/app-form/${id}/payroll`}
              label="Payroll Information"
              icon="fa-info-circle"
              isActive={isActive(`/emp/op/app-form/${id}/payroll`)} // Single path
              showError={true}
            />

            <SideNavItem
              href={`/emp/op/app-form/${id}/addresses`}
              label="Addresses"
              icon="fa-home"
              isActive={isActive(`/emp/op/app-form/${id}/addresses`)} // Single path
              showError={true}
            />

            <SideNavItem
              href={`/emp/op/app-form/${id}/qualification`}
              label="Trainings"
              icon="fa-star"
              isActive={isActive(`/emp/op/app-form/${id}/qualification`)} // Single path
              showError={true}
            />

            <SideNavItem
              href={`/emp/op/app-form/${id}/previous-history`}
              label="Previous History"
              icon="fa-solid fa-chart-simple"
              isActive={isActive(`/emp/op/app-form/${id}/previous-history`)} // Single path
              showError={true}
            />

            <SideNavItem
              href={`/emp/op/app-form/${id}/documents`}
              label="Documents"
              icon="fa-question-circle"
              isActive={isActive(`/emp/op/app-form/${id}/documents`)} // Single path
              showError={true}
            />

            <SideNavItem
              href={`/emp/op/app-form/${id}/siaQuestions`}
              label="SIA Knowledge Questionnaire"
              icon="fa-question-circle"
              isActive={isActive(`/emp/op/app-form/${id}/siaQuestions`)} // Single path
              showError={true}
            />

            <SideNavItem
              href={`/emp/op/app-form/${id}/references`}
              label="Personal References"
              icon="fa-tty"
              isActive={isActive(`/emp/op/app-form/${id}/references`)} // Single path
              showError={true}
            />

            <SideNavItem
              href={`/emp/op/app-form/${id}/health`}
              label="Occupational Health Section"
              icon="fa-stethoscope"
              isActive={isActive(`/emp/op/app-form/${id}/health`)} // Single path
              showError={true}
            />

            <SideNavItem
              href={`/emp/op/app-form/${id}/gdpr-notice`}
              label="GDPR Notice"
              icon="fa-times-circle"
              isActive={isActive(`/emp/op/app-form/${id}/gdpr-notice`)} // Single path
              showError={true}
            />

            <SideNavItem
              href={`/emp/op/app-form/${id}/declaration`}
              label="Policy and Declaration"
              icon="fa-times-circle"
              isActive={isActive(`/emp/op/app-form/${id}/declaration`)} // Single path
              showError={true}
            />

            <SideNavItem
              href={`/emp/op/app-form/${id}/uniform`}
              label="Uniform Issued"
              icon="fa-bag-shopping"
              isActive={isActive(`/emp/op/app-form/${id}/uniform`)} // Single path
              showError={true}
            />

            <SideNavItem
              href={`/emp/op/app-form/${id}/job-contract`}
              label="Submit Application"
              icon="fa-sign-out"
              isActive={isActive(`/emp/op/app-form/${id}/job-contract`)} // Single path
              showError={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideNav;
